/* eslint-disable no-param-reassign */
import {
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';

import { IShoutoutModalState } from '../types/tqConnectTypes/user';

export const initialShoutoutModalState: IShoutoutModalState = {
  isOpen: false,
};

interface ITQConnectUserSliceState {
  shoutoutModalState: IShoutoutModalState;
}

const initialState: ITQConnectUserSliceState = {
  shoutoutModalState: initialShoutoutModalState,
};

const tqConnectUserSlice = createSlice({
  name: 'tqConnectUser',
  initialState,
  reducers: {
    setShoutoutModalState: (
      state,
      action: PayloadAction<Partial<IShoutoutModalState>>,
    ) => {
      Object.assign(state.shoutoutModalState, action.payload);
    },
    resetShoutoutModalState: (state) => {
      state.shoutoutModalState = initialShoutoutModalState;
    },
    resetTQConnectUserState: () => initialState,
  },
});

export const {
  setShoutoutModalState,
  resetShoutoutModalState,
  resetTQConnectUserState,
} = tqConnectUserSlice.actions;

export default tqConnectUserSlice.reducer;
